import Router from "@/common/router/Router";

export default class RemoteConfigurationRouter extends Router {
  static entityName = "remote-configuration";
  static BASE_PATH = "/".concat(RemoteConfigurationRouter.entityName);
  static SHOW_ROUTE_NAME = RemoteConfigurationRouter.entityName.concat("-show");
  static CREATE_ROUTE_NAME = RemoteConfigurationRouter.entityName.concat("-create");
  static UPDATE_ROUTE_NAME = RemoteConfigurationRouter.entityName.concat("-update");
  static LIST_ROUTE_NAME = RemoteConfigurationRouter.entityName.concat("-list");

  constructor() {
    super(
      RemoteConfigurationRouter.BASE_PATH,
      RemoteConfigurationRouter.SHOW_ROUTE_NAME,
      RemoteConfigurationRouter.CREATE_ROUTE_NAME,
      RemoteConfigurationRouter.UPDATE_ROUTE_NAME,
      RemoteConfigurationRouter.LIST_ROUTE_NAME
    );
  }
}

export const remoteConfigurationRouter = new RemoteConfigurationRouter();
